import httpRequest from '../utils/httpRequest';
import API from '@/api';

const SERVER_NAME = 'foundation';

/**
 * 文件上传1
 * @param {FormData | FileList} data
 * @return {Promise<never>|Promise<AxiosResponse<any>>}
 */
export function attachUpload(data) {
    return httpRequest(
        {
            url: '/attach/upload',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
}
export const pictureView = `${API.server}${SERVER_NAME}/public/user/picture/view?path=`;
